import { CHANGE_PAGE_ACTION } from "../actions/questionnairesPaginiationAction";

export const questionnairesPaginiationReducer = ( state = 0, action) =>{
    switch (action.type){
        case CHANGE_PAGE_ACTION:
            const currentPage = action.payload;
            return currentPage
        default:
            return state
    }
}